import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PaymentProduct } from '../../../../model/payment/PaymentCollectionRequest';

@Component({
  selector: 'app-add-fund-popup',
  templateUrl: './add-fund-popup.component.html',
  styleUrls: ['./add-fund-popup.component.scss']
})
export class AddFundPopupComponent implements OnInit {
  private router: Router;
  private matDialogRef: MatDialogRef<AddFundPopupComponent>;
  public virtualAccountNumber: string;
  public fundAllocationMinimumAmount: number;
  public topupAmount: number;
  public isVirtualAccountDiscriptionOpen: boolean = false;
  constructor(router: Router, matDialogRef: MatDialogRef<AddFundPopupComponent>,
    @Inject(MAT_DIALOG_DATA) data: {
      virtualAccountNumber: string, 
      fundAllocationMinimumAmount: number,
      amount: number;
    }
  ) {
    this.router = router;
    this.matDialogRef = matDialogRef;
    this.virtualAccountNumber = data.virtualAccountNumber;
    this.fundAllocationMinimumAmount = data.fundAllocationMinimumAmount;
    (data.amount>0) ? (this.topupAmount = data.amount) : '';
  }

  ngOnInit(): void {
  }

  public async onAddMoneyClick(topupAmount) {
    this.matDialogRef.close(true);
    await this.router.navigate(['payment/initiate'], { state: { topUpAmount: topupAmount, paymentProduct: PaymentProduct.UPDATE_LENDER_WALLET } });
  }

  public isFormValid(isValidInputValue: boolean): boolean {
    return (isValidInputValue && this.topupAmount > 0);
  }

  public onClickVirtualAccountDiscriptionClose() {
    this.isVirtualAccountDiscriptionOpen = false;
  }

  public async onClickVirtualAccountDiscriptionOpen() {
    this.isVirtualAccountDiscriptionOpen = true;
    setTimeout(function () {
      const virtualAccountDiscriptionView = document.getElementById("virtualAccountDiscription");
      virtualAccountDiscriptionView.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }, 50);
  }
}
